export function operationKindLabel(kind) {
    if (kind === 'unassign_location')
        return 'Снятие с локации';
    if (kind === 'unassign_location_option')
        return 'Снятие с опции';
    return 'Неизвестная операция';
}
export function operationStatusLabel(status) {
    if (status === 'running')
        return 'Выполняется';
    if (status === 'completed')
        return 'Завершена';
    if (status === 'completed_with_errors')
        return 'Завершена с ошибками';
    return 'Неизвестный статус';
}
